export const SET_PROJECT = 'SET_PROJECT'
export const SET_INVENTORY_ITEM = 'SET_INVENTORY_ITEM'
export const SET_INVENTORY_BOX = 'SET_INVENTORY_BOX'
export const SET_LIST_INBOUND_FILE = 'SET_LIST_INBOUND_FILE'
export const SET_LIST_INBOUND_LOG = 'SET_LIST_INBOUND_LOG'
export const SET_LIST_ORDER_REQUEST = 'SET_LIST_ORDER_REQUEST'
export const SET_LIST_PICK_AND_PACK_PENDING = 'SET_LIST_PICK_AND_PACK_PENDING'
export const SET_LIST_ORDER_REQ_ITEM_WITH_IVENTORY = 'SET_LIST_ORDER_REQ_ITEM_WITH_IVENTORY'
export const SET_LIST_PICK_AND_PACK_PROGRESS = 'SET_LIST_PICK_AND_PACK_PROGRESS'
export const SET_LIST_EVIDENCE_CHECKLIST = 'SET_LIST_EVIDENCE_CHECKLIST'
export const SET_LIST_REQUEST_TRANSPORT_ARRANGEMENT = 'SET_LIST_REQUEST_TRANSPORT_ARRANGEMENT'
export const SET_LIST_DELIVERY_PENDING = 'SET_LIST_DELIVERY_PENDING'
export const SET_LIST_DELIVERY_TRANSIT = 'SET_LIST_DELIVERY_TRANSIT'
export const SET_LIST_DELIVERY_COMPLETE = 'SET_LIST_DELIVERY_COMPLETE'
export const SET_LIST_MASTER_LOCATION = 'SET_LIST_MASTER_LOCATION'
export const SET_LIST_HO_DOCUMENT = 'SET_LIST_HO_DOCUMENT'
export const SET_LIST_ITEM_REQUEST = 'SET_LIST_ITEM_REQUEST'
export const SET_LIST_ORDER_REQUEST_ADDITIONAL_SERVICE = 'SET_LIST_ORDER_REQUEST_ADDITIONAL_SERVICE'
export const SET_LIST_TRANSPORT_ARRANGEMENT_TYPE = 'SET_LIST_TRANSPORT_ARRANGEMENT_TYPE'
export const SET_LIST_TRANSPORT_ARRANGEMENT_SC = 'SET_LIST_TRANSPORT_ARRANGEMENT_SC'
export const SET_LIST_TRANSPORT_ARRAGEMENT = 'SET_LIST_TRANSPORT_ARRAGEMENT'
export const SET_LIST_ORDER_REQUEST_PICKUP = 'SET_LIST_ORDER_REQUEST_PICKUP'
export const SET_LIST_PICKUP_PREPARATION = 'SET_LIST_PICKUP_PREPARATION'
export const SET_LIST_DELIVERY_ONSITE = 'SET_LIST_DELIVERY_ONSITE'
export const SET_LIST_DELIVERY_ONSITE_EVIDENCE = 'SET_LIST_DELIVERY_ONSITE_EVIDENCE'
export const SET_LIST_WAITING_TRANSPORT_ASSIGNMENT = 'SET_LIST_WAITING_TRANSPORT_ASSIGNMENT'
export const SET_LIST_OUTBOUND = 'SET_LIST_OUTBOUND'
export const SET_LIST_TRANSPORT_ARRAGEMENT_ORDER_REQUEST =
  'SET_LIST_TRANSPORT_ARRAGEMENT_ORDER_REQUEST'
export const SET_LIST_WAITING_TRANSPORT_COMPLETE = 'SET_LIST_WAITING_TRANSPORT_COMPLETE'
export const SET_LIST_PICKUP_ONSITE = 'SET_LIST_PICKUP_ONSITE'
export const SET_LIST_HO_COMPLETE = 'SET_LIST_HO_COMPLETE'
export const SET_LIST_BACK_TO_POOL = 'SET_LIST_BACK_TO_POOL'
export const SET_LIST_PICKUP_TRANSIT = 'SET_LIST_PICKUP_TRANSIT'
export const SET_LIST_INVENTEORY_ITEM_DETAIL = 'SET_LIST_INVENTEORY_ITEM_DETAIL'
export const SET_LIST_INVENTEORY_BOX_DETAIL = 'SET_LIST_INVENTEORY_BOX_DETAIL'
export const SET_LIST_FINAL_CONFIRM = 'SET_LIST_FINAL_CONFIRM'
export const SET_LIST_FINAL_CONFIRM_COST_TRANSPORT_DELIVERY =
  'SET_LIST_FINAL_CONFIRM_COST_TRANSPORT_DELIVERY'
export const SET_LIST_FINAL_CONFIRM_WH_COST = 'SET_LIST_FINAL_CONFIRM_WH_COST'
export const SET_LIST_FINAL_COMPLETE = 'SET_LIST_FINAL_COMPLETE'
export const SET_LIST_FINAL_COMPLETE_ORDER_REQ = 'SET_LIST_FINAL_COMPLETE_ORDER_REQ'
export const SET_LIST_FINAL_COMPLETE_COST_TRANSPORT = 'SET_LIST_FINAL_COMPLETE_COST_TRANSPORT'
export const SET_LIST_FINAL_COMPLETE_WH_COST = 'SET_LIST_FINAL_COMPLETE_WH_COST'
export const SET_LIST_ORDER_REQUEST_BULK_DRAFT = 'SET_LIST_ORDER_REQUEST_BULK_DRAFT'
export const SET_LIST_PICKUP_DONE = 'SET_LIST_PICKUP_DONE'
export const SET_SELECTED_DATA_ORDER = 'SET_SELECTED_DATA_ORDER'
